import { render, staticRenderFns } from "./ThanksFooter.vue?vue&type=template&id=91f81034&"
import script from "./ThanksFooter.vue?vue&type=script&lang=js&"
export * from "./ThanksFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports